/**
 * Coure.Hub.Service.Creation
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AllServicePlanResponseDto } from '../model/allServicePlanResponseDto';
import { MapServicePlanRequestDto } from '../model/mapServicePlanRequestDto';
import { ServicePlanResponseDto } from '../model/servicePlanResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ServicePlanService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServicePlanGetAllServicePlanGet(observe?: 'body', reportProgress?: boolean): Observable<AllServicePlanResponseDto>;
    public apiServicePlanGetAllServicePlanGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllServicePlanResponseDto>>;
    public apiServicePlanGetAllServicePlanGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllServicePlanResponseDto>>;
    public apiServicePlanGetAllServicePlanGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AllServicePlanResponseDto>('get',`${this.basePath}/api/ServicePlan/GetAllServicePlan`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param planId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServicePlanGetServicePlanByPlanIdPlanIdGet(planId: string, observe?: 'body', reportProgress?: boolean): Observable<ServicePlanResponseDto>;
    public apiServicePlanGetServicePlanByPlanIdPlanIdGet(planId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServicePlanResponseDto>>;
    public apiServicePlanGetServicePlanByPlanIdPlanIdGet(planId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServicePlanResponseDto>>;
    public apiServicePlanGetServicePlanByPlanIdPlanIdGet(planId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (planId === null || planId === undefined) {
            throw new Error('Required parameter planId was null or undefined when calling apiServicePlanGetServicePlanByPlanIdPlanIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ServicePlanResponseDto>('get',`${this.basePath}/api/ServicePlan/GetServicePlanByPlanId/${encodeURIComponent(String(planId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServicePlanGetServicePlanByServiceIdServiceIdGet(serviceId: string, observe?: 'body', reportProgress?: boolean): Observable<ServicePlanResponseDto>;
    public apiServicePlanGetServicePlanByServiceIdServiceIdGet(serviceId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServicePlanResponseDto>>;
    public apiServicePlanGetServicePlanByServiceIdServiceIdGet(serviceId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServicePlanResponseDto>>;
    public apiServicePlanGetServicePlanByServiceIdServiceIdGet(serviceId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (serviceId === null || serviceId === undefined) {
            throw new Error('Required parameter serviceId was null or undefined when calling apiServicePlanGetServicePlanByServiceIdServiceIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ServicePlanResponseDto>('get',`${this.basePath}/api/ServicePlan/GetServicePlanByServiceId/${encodeURIComponent(String(serviceId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServicePlanMapServicePlanPost(body?: MapServicePlanRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ServicePlanResponseDto>;
    public apiServicePlanMapServicePlanPost(body?: MapServicePlanRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServicePlanResponseDto>>;
    public apiServicePlanMapServicePlanPost(body?: MapServicePlanRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServicePlanResponseDto>>;
    public apiServicePlanMapServicePlanPost(body?: MapServicePlanRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ServicePlanResponseDto>('post',`${this.basePath}/api/ServicePlan/MapServicePlan`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
